import React from 'react'

const TagComponent = ({ value }) => {
    return (
        <div className='bg-dark text-light mr-2 py-2 mb-3 font-bold px-8 capitalize w-fit float-left rounded'>{value}</div>
    )
}

export default TagComponent